@if (reInit) {
  <div class="dense-1">
    <mat-form-field [fxFlex]="field.customfield4 === '2' || field.customfield4 === '4' ? 50 : 100 " appearance="outline">
      <mat-label>
        {{field.label}} @if (isRequired(field.name)) {
        <span class="required-symbol">*</span>
      }
    </mat-label>
    <mat-select (selectionChange)="setValue($event.value)" [placeholder]="field.label"
      [formControl]="localFormControl">
      @for (item of optionsList; track item) {
        <mat-option [value]="item">{{item}}</mat-option>
      }
    </mat-select>
    @for (validation of field['dynamicFormLabelValidator']; track validation) {
      <mat-hint>{{validation.hintMessage}}</mat-hint>
    }
  </mat-form-field>
  @if (field.customfield4 === '2') {
    <div>
      @if (selectedValue) {
        <div>
          <div class="padding-10" fxLayout="column">
            <div fxLayout="row">
              <p>{{field.label}}: {{selectedCustomFieldValue}}</p>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (field.customfield4 === '4') {
    <div>
      @if (selectedValue) {
        <div>
          <div style="padding-left: 10px;" fxLayout="column">
            <form [formGroup]="secondFormGroup">
              <div fxLayout="row">
                <mat-form-field fxFlex="100" appearance="outline">
                  <mat-label>{{selectedOptions}} Amount</mat-label>
                  <input matInput formControlName="amount" required>
                  @if (secondFormGroup.controls.amount.errors?.required) {
                    <mat-error>
                      Please fill out this field.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      }
    </div>
  }
</div>
}
